import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b3d3f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex justify-center fork",
  style: {"display":"none"}
}
const _hoisted_2 = {
  key: 0,
  class: "nes-balloon from-right balloon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Fork me on Github", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  href: "https://github.com/gemworks/gem-farm",
  target: "_blank",
  class: "cat"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_5, [
      _createElementVNode("i", {
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showText = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showText = false)),
        class: "nes-octocat animate"
      }, null, 32)
    ])
  ]))
}